import React, { useEffect, useState } from 'react';
import moment from 'moment';
import TaskStatistic from './TaskStatistic';
import { secondsToTime } from '../../../utils/time';
import { usePublicTasksByBoard } from '../../../firebase/api/boards-public';
import { getActivityByDay } from '../../../firebase/api/tracking';
import { Title, NoTasks, Day, BoardWrapper, BoardPreloader } from './styled';

interface IDayTask {
  day: string;
  tasks: { date: number; seconds: number; taskId: string }[];
}

const BoardStatistic: React.FC<{
  boardId: string;
  boardTitle: string;
  userId: string;
  day: number;
  setTotalSecondsPerBoard: (boardId: string, seconds: number) => void;
}> = (props) => {
  const { tasks, objects } = usePublicTasksByBoard(props.boardId);
  const myTaskIds = tasks?.map((t) => String(t.id)) || [];
  const [dayTasks, setDayTasks] = useState<IDayTask[]>([]);
  const [loading, setLoading] = useState(false);

  const getTotalSeconds = (tasks: { seconds: number }[]) => {
    return (
      tasks?.reduce((prev, cur) => {
        return prev + cur.seconds;
      }, 0) || 0
    );
  };

  const getTotalSecondsPerBoard = () => {
    const berBoard = dayTasks.map((t) => ({ seconds: getTotalSeconds(t.tasks) }));
    return getTotalSeconds(berBoard);
  };

  const totalSecondsPerBoard = getTotalSecondsPerBoard();

  useEffect(() => {
    !!totalSecondsPerBoard && props.setTotalSecondsPerBoard(props.boardId, totalSecondsPerBoard);
  }, [totalSecondsPerBoard]);

  const getActivity = async () => {
    setLoading(true);
    const dayActivity = await getActivityByDay(props.userId, props.day);
    const taskIds = dayActivity && Object.keys(dayActivity);
    const reports = [
      {
        day: String(props.day),
        tasks: !!taskIds
          ? taskIds
              .filter((taskId: string) => myTaskIds.includes(String(taskId)))
              .map((id: string) => dayActivity[id])
          : [],
      },
    ];
    reports && setDayTasks(reports);
    setLoading(false);
  };

  useEffect(() => {
    getActivity();
  }, [tasks, props.day]);

  return (
    <BoardWrapper>
      {loading ? (
        <BoardPreloader />
      ) : (
        <>
          {dayTasks && !!totalSecondsPerBoard && (
            <>
              <Title>
                <span>{props.boardTitle}</span>
                <span>{secondsToTime(totalSecondsPerBoard)}</span>
              </Title>
              {dayTasks.map((w, index) => {
                return !w.tasks.length ? null : (
                  <div key={index}>
                    {/* <Day>{moment(Number(w.day)).format('DD.MM.YYYY')}</Day> */}
                    {w.tasks.length ? (
                      w.tasks.map((task) => (
                        <TaskStatistic
                          key={task.taskId}
                          day={props.day}
                          screenshotsDate={w.day}
                          seconds={task.seconds}
                          taskId={task.taskId}
                          taskName={objects[task.taskId].taskName}
                          userId={props.userId}
                        />
                      ))
                    ) : (
                      <NoTasks>Нет данных</NoTasks>
                    )}
                  </div>
                );
              })}
            </>
          )}
        </>
      )}
    </BoardWrapper>
  );
};

export default BoardStatistic;
